import { useCountDown } from 'hooks/common';
import messages from './VerifyResendCode.messages';
import styles from './VerifyResendCode.module.css';

const INITIAL_SECONDS = 60;
const INITIAL_RUNNING = true;

type Props = {
  initialSeconds?: number;
  initialRunning?: boolean;
  resendCode: () => Promise<void>;
};

const VerifyResendCode = ({
  initialSeconds = INITIAL_SECONDS,
  initialRunning = INITIAL_RUNNING,
  resendCode,
}: Props): JSX.Element => {
  const { seconds, start } = useCountDown({
    seconds: initialSeconds,
    running: initialRunning,
  });

  const onResendCode = async (): Promise<void> => {
    start(INITIAL_SECONDS);
    resendCode();
  };

  return (
    <button
      className={styles.verify__resend}
      disabled={Boolean(seconds)}
      onClick={onResendCode}
    >
      {seconds ? messages.resendPending : messages.resendReady}

      {Boolean(seconds) && (
        <span>
          {'00:'}
          {seconds < 10 ? `0${seconds}` : seconds}
        </span>
      )}
    </button>
  );
};

export default VerifyResendCode;
